<div [ngClass]="liatContainerClass" class="list-container" id="listContainer">

  <ng-container *ngIf="showFilters">
    <div class="blockFilterSorting">
      <div class="filters" id="block-list-filter-container" #filtersContainer
           (cdkObserveContent)="onUpdateFiltersContent()">
        <div *ngFor="let block of filters" [class]="block.uId" [item]="block" app-block></div>
      </div>
    </div>
  </ng-container>

  <div class="no-results" *ngIf="noResults?.length">
    <div *ngFor="let block of noResults" [class]="block.uId" [item]="block" app-block></div>
  </div>

  <div #listContainer class="list" [style.display]="noResults?.length ? 'none' : 'block'">
    <ng-container *ngIf="!noResults?.length">
      <ng-container *ngIf="tabs">
        <div *ngFor="let block of tabs" [class]="block.uId" [item]="block" app-block></div>
      </ng-container>

      <div *ngFor="let block of header" [class]="block.uId" [item]="block" app-block></div>

      <div class="sorting" id="block-list-sorting-container" #sortContainer
           (cdkObserveContent)="onUpdateFiltersContent()">
        <div *ngFor="let block of sorting" [class]="block.uId" [item]="block" app-block></div>
      </div>

      <ng-container *ngFor="let view of structure">
        <div *ngIf="view.viewName === activeTab" [attr.data-viewName]="view.viewName" [ngClass]="listContainerClass"
             [ngStyle]="listContainerStyle">

          <ng-container *ngIf="isMasonryList; else normalList">
            <div *ngFor="let column of masonryList[view.viewName]; let j = index" class="masonry-column">
              <div *ngFor="let item of column; let i = index" [id]="'item-' + i" class="list-item">
                <div app-block-container [children]="item"></div>
              </div>
            </div>

          </ng-container>

          <ng-template #normalList>
            <div *ngFor="let item of view.data; let i = index" [id]="'item-' + i" class="list-item">
              <div app-block-container [children]="item"></div>
            </div>
          </ng-template>

        </div>
      </ng-container>

      <div *ngIf="!showMainLoader && (loadingFilters | async)" class="loader-container fixed">
        <app-loaders-wrapper-small></app-loaders-wrapper-small>
      </div>

    </ng-container>
  </div>

</div>
<div *ngIf="!showMainLoader && (loading | async)" class="loader-container centered">
  <app-loaders-wrapper-small [className]="'loaderCenter'"></app-loaders-wrapper-small>
</div>
<div *ngIf="validPaginator()" class="pagination">
  <div *ngFor="let block of pagination" [class]="block.uId" [item]="block" app-block>
  </div>
</div>
